import React from 'react';
import { Container, Typography, Box, Paper, Grid, Button } from '@mui/material';
import { School as TrainingIcon, PlayArrow as PlayIcon } from '@mui/icons-material';

const TrainingResources: React.FC = () => {
  const courses = [
    { title: 'Data Governance Fundamentals', duration: '2 hours', level: 'Beginner' },
    { title: 'Data Stewardship Best Practices', duration: '3 hours', level: 'Intermediate' },
    { title: 'DHS Compliance Training', duration: '1.5 hours', level: 'All Levels' },
    { title: 'Data Quality Management', duration: '2.5 hours', level: 'Advanced' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <TrainingIcon sx={{ fontSize: 40 }} />
          Training & Resources
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Educational materials and training programs
        </Typography>
      </Box>

      <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
        Available Courses
      </Typography>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {courses.map((course, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>{course.title}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {course.duration} • {course.level}
              </Typography>
              <Button variant="outlined" startIcon={<PlayIcon />} size="small">
                Start Course
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Documentation
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Data Governance Framework Guide
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → DHS Compliance Handbook
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Best Practices Library
            </Typography>
            <Typography variant="body2" color="text.secondary">
              → Quick Reference Guides
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Resources
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Video Tutorials
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Webinar Recordings
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Templates & Tools
            </Typography>
            <Typography variant="body2" color="text.secondary">
              → Community Forum
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Learning Management System Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Interactive courses, Progress tracking, Certifications, Knowledge assessments.
        </Typography>
      </Paper>
    </Container>
  );
};

export default TrainingResources;
